import React from "react";
import {IconButton, Stack, TextField, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon, Cancel01Icon} from "@hugeicons/core-free-icons";
import {v4 as uuidv4} from "uuid";
import {fieldSx, iconBtnDangerSx, iconBtnSx} from "../editMenuStyles";
import {SubSectionHeader} from "./EditMenuSection";

/**
 * Key / value "Custom Params" editor — shared by the Settings, Settings-tools
 * and Settings-booster tabs (was copy-pasted in all three).
 */
export const SettingsCustomParams = ({node, setNode, onUpdate}) => {
    const params = node?.data?.custom_params || {};
    const keys = Object.keys(params).sort();

    const addParam = () => {
        setNode(prev => {
            const state = {...prev};
            if (!state?.data?.custom_params) {
                state.data.custom_params = {};
            }
            state.data.custom_params[uuidv4()] = "";
            return state;
        });
    };

    return (
        <Stack gap={1}>
            <SubSectionHeader
                title="Custom Params"
                action={
                    <Tooltip title="Add custom param" disableInteractive>
                        <IconButton size="small" onClick={addParam} sx={iconBtnSx}>
                            <HugeiconsIcon icon={Add01Icon} size={16}/>
                        </IconButton>
                    </Tooltip>
                }
            />
            {keys.map((key) => (
                <Stack direction="row" gap={0.75} alignItems="center" key={key}>
                    <TextField
                        size="small"
                        defaultValue={key}
                        InputLabelProps={{shrink: true}}
                        sx={{flex: 1, ...fieldSx}}
                        onBlur={(e) => {
                            setNode(prev => {
                                const state = {...prev};
                                if (!state?.data?.custom_params) {
                                    state.data.custom_params = {};
                                }
                                const value = state.data.custom_params[key] || "";
                                delete state.data.custom_params[key];
                                state.data.custom_params[e.target.value] = value;
                                onUpdate(state);
                                return state;
                            });
                        }}
                    />
                    <TextField
                        size="small"
                        value={params[key] || ""}
                        InputLabelProps={{shrink: true}}
                        sx={{flex: 1, ...fieldSx}}
                        onChange={(e) => {
                            setNode(prev => {
                                const state = {...prev};
                                if (!state?.data?.custom_params) {
                                    state.data.custom_params = {};
                                }
                                state.data.custom_params[key] = e.target.value;
                                return state;
                            });
                        }}
                        onBlur={() => onUpdate(node)}
                    />
                    <IconButton
                        size="small"
                        sx={iconBtnDangerSx}
                        onClick={() => {
                            setNode(prev => {
                                const state = {...prev};
                                delete state.data.custom_params[key];
                                return state;
                            });
                        }}
                    >
                        <HugeiconsIcon icon={Cancel01Icon} size={15}/>
                    </IconButton>
                </Stack>
            ))}
        </Stack>
    );
};
